import React from 'react';
import { moduleApi } from '../../lib/api';
import { CadreApercu } from './ApercuDocument';

/**
 * Aperçu du contrat d'abonnement, affiché DIRECTEMENT dans le panneau du pipeline de Suivi de prestation —
 * même esprit que DevisSigneApercuPrestation.tsx (jamais un bouton qui renvoie ailleurs, demande répétée
 * d'Emeni). Le contrat n'a pas de document stocké côté serveur (généré à la volée) : le PDF est régénéré
 * ici au chargement, silencieusement, et affiché en iframe sans action de l'utilisateur.
 */
export function ContratApercuInline({ subscriptionId }: { subscriptionId: string }) {
    const [chargement, setChargement] = React.useState(true);
    const [erreur, setErreur] = React.useState('');
    const [url, setUrl] = React.useState('');

    React.useEffect(() => {
        let annule = false;
        let objectUrl = '';
        (async () => {
            try {
                const data: any = await moduleApi.getSubscriptionContractData(subscriptionId);
                if (data?.error) throw new Error(data.error);
                const { generateContractPdfFromData } = await import('../Abonnements/contractPdfGenerator');
                const { blob } = await generateContractPdfFromData(data);
                if (annule) return;
                objectUrl = URL.createObjectURL(blob);
                setUrl(objectUrl);
            } catch (e: any) {
                if (!annule) setErreur(e?.message || "L'aperçu n'a pas pu être généré.");
            } finally {
                if (!annule) setChargement(false);
            }
        })();
        return () => { annule = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
    }, [subscriptionId]);

    return <CadreApercu titre="Contrat d'abonnement" url={url} chargement={chargement} erreur={erreur} />;
}
